
<template>

  <v-card>
    
      <v-expansion-panels v-model="panelActivo">
        <v-subheader><h3>Carga de Incidencias</h3></v-subheader>
        <v-expansion-panel>
          <v-expansion-panel-header>Manual</v-expansion-panel-header>
            <v-expansion-panel-content>
            <v-card class="pa-4">
              <!-- FORMULARIO -->
              <v-form ref="form" lazy-validation @submit.prevent>
                <v-row dense>
                  <v-col cols="12" sm="3" class="pa-2">
                    <v-text-field
                      label="Punto"
                      v-model="ManualItem.punto"
                      outlined
                      dense
                    />
                  </v-col>

                  <v-col cols="12" sm="3" class="pa-2">
                    <v-text-field
                      label="Nro Orden"
                      v-model="ManualItem.orden"
                      outlined
                      dense
                    />
                  </v-col>
<!--  Comentado para cambiar por select
                  <v-col cols="12" sm="3" class="pa-2">
                    <v-text-field
                      label="Proveedor"
                      v-model="ManualItem.proveedor"
                      outlined
                      dense
                    />
                  </v-col>
-->

                  <v-col cols="12" sm="3" class="pa-2">
                    <v-autocomplete
                      label="Proveedor"
                      v-model="ManualItem.proveedor"
                      :items="Allproveedores"
                      :item-text="item => `${item.Supplier_id} - ${item.Supplier_Description}`"
                      item-value="Supplier_id"
                      outlined
                      dense
                      clearable
                      hide-no-data
                      hide-selected
                    />
                  </v-col>

                  <v-col cols="12" sm="3" class="pa-2">
                    <v-select
                      label="Tipo de Incidencia"
                      :items="IssueTypes"
                      :item-text="item => `${item.tipo} - ${item.desc}`"
                      item-value="tipo"
                      v-model="ManualItem.IncideType"
                      outlined
                      dense
                    />
                    
                  </v-col>

                  
                </v-row>

                <v-row >
                  <v-col cols="12" sm="7" class="pa-2">
                    <v-textarea
                      label="Comentario"
                      v-model="ManualItem.comentario"
                      outlined
                      rows="3"
                      auto-grow
                    />
                  </v-col>
                  
                  <v-col cols="12" sm="5" class="pa-2 d-flex align-center">
                    <v-file-input 
                      label="Seleccione su archivo"
                      v-model="ManualItem.files"
                      outlined
                      dense
                      prepend-icon="mdi-paperclip"
                      accept="image/png,image/jpeg,.png,.jpg,.jpeg"
                      name="file"  
                      id="file"
                      :rules="filerules"
                    />
                  </v-col>
                  
                </v-row>
              </v-form>

              <v-row justify="center">
                <v-col cols="12" sm="6" md="4" class="text-center">
                  <v-btn type="button" :disabled="ManualItem.files.length == 0" color="success" class="ml-2" @click="carga_manual">Cargar</v-btn>
                </v-col>
              </v-row>

            </v-card>
          </v-expansion-panel-content>

        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Masiva</v-expansion-panel-header>
            <v-expansion-panel-content>
            <v-card class="pa-4">

              <v-row justify="center">
                <v-col cols="12" sm="6" md="4" class="text-center">
                  <v-container>
                    <template>
                      <v-file-input v-model="editedItem.files"
                        accept=".xlsx"
                        label="Archivo excel"
                        placeholder="Seleccione su archivo"
                        name="file"  
                        id="file"
                      ></v-file-input>
                    </template>
                  </v-container>
                  
                  <v-btn :disabled="editedItem.files.length == 0" color="success" class="ml-2" @click="carga">Cargar</v-btn>
                  

                </v-col>
              </v-row>

            </v-card>
          </v-expansion-panel-content>

        </v-expansion-panel>
        <v-subheader><h3>Descarga de Incidencias</h3></v-subheader>
        <v-expansion-panel>
          <v-expansion-panel-header>Consulta</v-expansion-panel-header>
            <v-expansion-panel-content>
            <v-card class="pa-4">
              <!-- FORMULARIO -->
              <v-form>
                <v-row dense>
                  <v-col cols="12" sm="2" class="pa-2">
                    <v-text-field
                      label="Fecha Desde"
                      v-model="busquedaItem.start_dt"
                      type="date"
                      outlined
                      dense
                    />
                  </v-col>

                  <v-col cols="12" sm="2" class="pa-2">
                    <v-text-field
                      label="Fecha Hasta"
                      v-model="busquedaItem.end_dt"
                      type="date"
                      outlined
                      dense
                    />
                  </v-col>

                  <v-col cols="12" sm="2" class="pa-2">
                    <v-autocomplete
                      label="Proveedor (Opcional)"
                      v-model="busquedaItem.proveedor"
                      :items="proveedores"
                      :item-text="item => `${item.value} - ${item.text}`"
                      item-value="value"
                      outlined
                      dense
                      clearable
                      hide-no-data
                      hide-selected
                    />
                  </v-col>

                  <v-col cols="12" sm="2" class="pa-2">
                    <v-autocomplete
                      label="Razón Social(Opcional)"
                      v-model="busquedaItem.razonSocial"
                      :items="razonesSociales"
                      :item-text="item => `${item.text}`"
                      item-value="text"
                      outlined
                      dense
                      clearable
                      hide-no-data
                      hide-selected
                    />
                  </v-col>

                  <v-col cols="12" sm="2" class="pa-2">
                    <v-text-field
                      label="Punto (Opcional)"
                      v-model="busquedaItem.punto"
                      outlined
                      dense
                      clearable
                    />
                  </v-col>

                  <v-col cols="12" sm="2" class="pa-2">
                    <v-autocomplete
                      label="Marca"
                      v-model="busquedaItem.Marcadesc"
                      :items="Marcas"
                      :item-text="item => `${item.text}`"
                      item-value="text"
                      outlined
                      dense
                      clearable
                      hide-no-data
                      hide-selected
                    />
                  </v-col>
                </v-row>
              </v-form>

              <v-row justify="center">
                <v-col cols="12" sm="6" md="4" class="text-center">
                  <v-btn color="success" class="ml-2" @click="carga_busqueda">Consultar</v-btn>
                </v-col>
              </v-row>

           
    <v-container fluid class="px-0">
      <v-card>
       <v-card-title>
         <v-icon x-large>mdi-clipboard-list-outline</v-icon>Reporte
         <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Filtro"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
      :headers="headers"
      :items="mvm"
      :search="search"
      sort-by="calories"
      class="elevation-1"
    >
    
    <!-- Slot para la columna de Ver -->
    <template v-slot:item.view="{ item }">
      
      <v-btn
        small
        color="blue"
        outlined
        :disabled="item.hasFile !== 1"
        @click="viewDocument(item.ReceivingIssue_Id)"
      >
        <v-icon left>mdi-eye</v-icon>
        Ver
      </v-btn>
    </template>

    </v-data-table>
    </v-card>
    </v-container>
    <v-spacer></v-spacer>
  
    <v-dialog v-model="dialog_new" max-width="900px" :z-index="3000">
    <v-stepper v-model="e1" vertical>
           <p align="right"><v-btn color="blue darken-1" text @click="close">X</v-btn></p>
          <v-stepper-step :complete="e1 > 1" step="1" :rules="[value => !! step_error1]" :color="step_color1">{{ this.step_txt1 }}
              <small>{{this.step_txt2}}</small>
          </v-stepper-step>
          <v-stepper-content step="1">
          <v-card height="100px">
              <div class="text-center">
              <v-progress-circular v-if="progressBar" indeterminate  color="primary"></v-progress-circular><br>
              {{this.msj_proceso}}
              </div>
          </v-card>
          </v-stepper-content>  
      </v-stepper>
    </v-dialog>


    <!-- Dialogo para ver el PDF -->
    <v-dialog v-model="dialogpdf" max-width="900px" >
      <v-card>
        <v-card-title>
      <!-- Botón de cierre (X) en la parte superior derecha -->
          <v-spacer></v-spacer>
          <v-btn
            @click="dialogpdf = false"
            color="primary"
            top
            right
            icon
            class="close-btn"
          >
          <v-icon>mdi-close</v-icon> <!-- Icono X -->
          </v-btn>
        </v-card-title>
        <v-card-text class="image-container">
        <!-- Canvas para mostrar el PDF -->
          <img :src="url" class="issue-image" />

        </v-card-text>

    </v-card>
  </v-dialog>
  
    <template>
      <div class="d-flex justify-center" style="gap: 8px">
          <v-btn :disabled="!hasMvmData" type="button" color="success" @click="onexport" >Descargar Reporte Excel</v-btn>
          <v-btn :disabled="!hasMvmData" type="button" color="success" @click="descargapdf">Descargar Reporte Excel con Imagen</v-btn>
          <v-btn :disabled="!hasMvmData" type="button" color="success" @click="descargapdf_2">Descargar Reporte PDF</v-btn>
      </div>
    </template>

  </v-card>
      </v-expansion-panel-content>

      </v-expansion-panel>
    </v-expansion-panels>
    <!-- Loading Overlay -->
    <v-overlay :value="loadingProveedores" :z-index="2000">
        <v-progress-circular indeterminate size="100" color="primary"></v-progress-circular>
      </v-overlay>
  </v-card>
  

      
  </template>
  
  <script>
  import axios from 'axios'
  //import Vue from "vue";
  //import JsonExcel from "vue-json-excel";
  import XLSX from 'xlsx';
   
  //Vue.component("downloadExcel", JsonExcel);
  
  export default {
    data: () => ({
      url:'',
      search: '',
      search2: '',
      api_tool_url: process.env.VUE_APP_API_TOOL_URL,
      dialog: false,
      dialogCarga: false,
      dialog_pass: false,
      dialog_new: false,
      dialog_detail: false,
      dialogpdf:false,
      valid: true,
      menu: false,
      menu2: false,
      menu3: false,
      e1: 0,
      btnap:true,
      btn: false,
      msj_proceso:'',
      msj_pdf:'',
      progressBar1: false,
      progressBar: false,
      progressBarPDF: false,
      overlay: false,
      step_error1: true,
      step_error2: true,
      step_error3: true,
      step_color1:"primary",
      step_color2:"primary",
      step_color3:"primary",
      RequestProposal_id:'',
      step_txt1:'',
      step_txt2:'',
      isTester: false,
      panelActivo: null,
      headers: [
        { text: 'id', value: 'ReceivingIssue_Id' },
        { text: 'Fecha Incidencia', value: 'Cday_id' },
        { text: 'Punto', value: 'OpPoint_id' },
        { text: 'OC', value: 'VendorPurchaseOrder_Num' },
        { text: 'Proveedor', value: 'TurnSrcSupplier_id'},
        { text: 'Razón Social', value: 'TurnSrcSupplier_desc'},
        {text:  'Tipo Incidencia', value:'IssueType_Id'},
        { text: 'Comentario CD', value: 'Comment_Txt' },
        { text: 'Fecha Turno', value: 'TurnDate' },
        { text: 'Hora Turno', value: 'TurnHour' },
        { text: 'Marca Desc', value: 'TradeMarkType_Description'},
        { text: 'Pallets', value: 'qty_pa'},
        { text: 'Bultos Ultimo Valor', value:'qty_bu'},
        { text: 'Status Mail', value:'MailStatus'},
        { text: "Ver", value: "view", sortable: false }, // Columna para botón Ver
                 
      ],
      mvm: [],
      editedIndex: -1,
      editedItem: {
      start_dt: new Date().toISOString().substr(0, 10),
      end_dt: new Date().toISOString().substr(0, 10),
      Namefile: '',
      fecha: new Date().toISOString().substr(0, 10),
      files: []
     },
     ManualItem: {
      punto: '',
      proveedor:'' ,
      orden: '',
      comentario: '',
      IncideType: '',
      files: []
     },
     busquedaItem: {
      start_dt: new Date().toISOString().substr(0, 10),
      end_dt: new Date().toISOString().substr(0, 10),
      proveedor: null,
      punto: null, 
      razonSocial: null,
      Marcadesc: null
     },
     proveedores: [],
     searchProveedor: '',
     loadingProveedores: false,
     Allproveedores: [{Supplier_id: "Cargando", Supplier_Description: "Espere..."}],
     IssueTypes: [
      {tipo: 'CE', desc:'CONDICION DE ENTREGA'}
      ,{tipo: 'AT', desc:'ANULADA O TRASMITIDA'}
      ,{tipo: 'FH', desc:'FUERA DE HORARIO'}
      ,{tipo: 'EX', desc:'EXTRAPLANNING'}
      ,{tipo: 'CA', desc:'COSTOS ADICIONALES'}
     ],
     razonesSociales: [],
     Marcas: [],
      filerules: [
      v => !!v || 'El archivo es requerido',
      v =>
        !v ||
        ['image/png', 'image/jpeg'].includes(v.type) ||
        'Solo se permiten imágenes',
      v => {
        if (!v) return true
        const file = Array.isArray(v) ? v[0] : v
        if (!file || typeof file.size !== 'number') return true
        return file.size < 5000000 || 'Máx 5 MB'
      }
      
      ],
      filerules1: [
      v => !!v || 'El archivo es requerido'
      ],
             
      fechaRule: [
          v => !!v || 'Fecha es requerida'
      ],
      datoRule: [
          v => !!v || 'El dato es Requerido'
         
      ],
      
      config: {
        headers: {
          //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
          "api-user": sessionStorage.getItem('ApiUser_id')
        }
      }
    }),
  
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Planning' : 'Editar Planning'
      },
      hasMvmData () {
        return Array.isArray(this.mvm) && this.mvm.length > 0
      },

      habilitarCarga () {
        //return !!this.busquedaItem.proveedor
        return this.ManualItem.files != []
      }
    },
  
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    created () {
      this.$store.commit('updateTitle', 'Reporte de Incidencias')
      this.initialize()
      this.obtenerProveedores()
      this.obtenerMarca()
    },
    mounted() {
     
    },
  
    methods: {
      initialize () {
        this.loadingProveedores = true
        
        axios.post(this.api_tool_url + '/get_allsuppliers', {}, this.config)
        .then(response => {
          if (response.data.ResultRows.length > 0) {
            this.Allproveedores = response.data.ResultRows
          } else {
            this.Allproveedores = []
          }
        })
        .catch(err => {
          console.error('Error proveedores', err)
          this.Allproveedores = []
        })
        .finally(() => {
          this.loadingProveedores = false
          this.$nextTick(() => {
            this.panelActivo = 2   // índice del panel a abrir
          })
        })
                      
      },
      obtenerProveedores(){
        //this.loadingProveedores = true
        axios.post(this.api_tool_url + '/get_suppliersissue', {}, this.config)
        .then(response => {
          if (response.data.success) {
            this.proveedores = response.data.items
            this.razonesSociales = [...new Set(response.data.items.map(razon => razon.text))];
          } else {
            this.proveedores = []
          }
        })
        .catch(err => {
          console.error('Error proveedores', err)
          this.proveedores = []
        })
        
      },

      obtenerMarca(){
        //this.loadingProveedores = true
        axios.post(this.api_tool_url + '/get_TradeMarkTypeIssue', {}, this.config)
        .then(response => {
          if (response.data.success) {
            this.Marcas = response.data.items
          } else {
            this.Marcas = []
          }
        })
        .catch(err => {
          console.error('Error proveedores', err)
          this.proveedores = []
        })
        
      },
      viewDocument(ReceivingIssue_Id){
        //console.log(ReceivingIssue_Id)
        this.step_txt1="Consultando Imagen"
        this.step_txt2=""
        this.dialog_new = true
        this.e1 = 1
        this.progressBar = true
        this.step_error1 = true
        this.step_error2 = true
        this.step_error3 = true
        this.step_color1 = "primary",
        this.step_color2 = "primary",
        this.step_color3 = "primary",
        this.msj_proceso = "Por favor aguarde un momento ¡No cerrar esta ventana!"
        let data = new FormData()
        data.append('foo', 'bar');
        data.append('idfile', ReceivingIssue_Id);
        
        axios.post(this.api_tool_url + '/get_viewdocumentissue', data, this.config)
              .then(response => {
                      let mime = 'image/jpeg'
                      
                      const rows = response.data.ResultRows
                      if (rows && rows.length > 0 && rows[0].Issuefile) {
                        this.dialog_new = false
                        this.dialogpdf = true
                        if (rows[0].Issuefile.startsWith('iVBOR')) {
                          mime = 'image/png'
                        }
                        this.url = 'data:' + mime + ';base64,' + rows[0].Issuefile
                        //this.url = 'data:image/png;base64,' + rows[0].Issuefile
                      } else {
                        // No hay archivo
                        this.dialogpdf = false
                        this.step_txt1="Ocurrio un error"
                        this.e1 = 1
                        this.step_color1 = "#C0392B"
                        this.progressBar = false
                        this.msj_proceso = "No se pudo recuperar la imagén."
                      }
                      
                  })
                  .catch(error => {
                    this.step_txt1="Ocurrio un error"
                    this.step_error1 = false
                    this.progressBar = false
                    this.msj_proceso = error.message
                  })

      },
      carga() {
                this.btn = true
                this.step_txt1="Realizando Carga Masiva"
                this.step_txt2=" "
                this.dialog_new = true
                this.e1 = 1
                this.progressBar = true
                this.step_error1 = true
                this.step_error2 = true
                this.step_error3 = true
                this.btnap=true
                this.step_color1 = "primary",
                this.step_color2 = "primary",
                this.step_color3 = "primary",
                this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
                let data = new FormData();
                data.append('foo', 'bar');
                data.append('file', document.getElementById('file').files[0]);
                //data.append('email', sessionStorage.getItem('ApiUser_EMail'));
                data.append('user', sessionStorage.getItem('ApiUser_id'));
                
              axios.post(this.api_tool_url + '/ExcelUpload_issue', data, this.config)
              .then(response => {
                      //if(response.data.ResultRows.length >= 1) {
                      if(response.data && response.data.ResultRows && response.data.ResultRows.length >= 1) {
                          
                          this.btnap=true
                          this.e1 = 1
                          this.step_color1 = "#008000"
                          this.progressBar = false
                          this.msj_proceso = response.data.ResultRows
                          this.btn = false
                          this.active = false
                          this.editedItem.files = []
                          this.obtenerProveedores()
                          
                      }
                      else {
                          this.e1 = 1
                          this.step_color1 = "#C0392B"
                          this.progressBar = false
                          this.msj_proceso = error
                          this.btn = false
                          this.active = true
                          this.editedItem.files = []
                      }
                      this.btn = false
                  })
                  .catch(error => {
                      this.btn = false
                      this.step_error1 = false
                      this.progressBar = false
                      if (error.response && error.response.data && error.response.data.message) {
                          this.msj_proceso = error.response.data.message;
                      } else {
                          this.msj_proceso = 'Ocurrió un error al procesar el archivo.';
                      }
                      this.active = true
                  })           
            },
      carga_busqueda() {
                this.step_txt1="Consultando Datos"
                this.step_txt2=" "
                this.dialog_new = true
                this.e1 = 1
                this.progressBar = true
                this.step_error1 = true
                this.step_error2 = true
                this.step_error3 = true
                this.step_color1 = "primary",
                this.step_color2 = "primary",
                this.step_color3 = "primary",
                this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
                this.mvm = []
              console.log(this.busquedaItem)
              axios.post(this.api_tool_url + '/get_supplierReport', this.busquedaItem, this.config)
              .then(response => {
                      //if(response.data.ResultRows.length >= 1) {
                      if(response.data && response.data.ResultRows && response.data.ResultRows.length >= 1) {

                          this.mvm = response.data.ResultRows
                          this.e1 = 1
                          this.step_color1 = "#008000"
                          this.progressBar = false
                          this.msj_proceso = 'Se realizo consulta correctamente.'
                          this.active = false  
                      }
                      else {
                        this.step_txt1="Ocurrio un error"
                        this.e1 = 1
                        this.step_color1 = "#C0392B"
                        this.progressBar = false
                        this.msj_proceso = 'No se encontraron registros'
                          
                      }
                      
                  })
                  .catch(error => {
                    console.error('ERROR COMPLETO:', error)
                    if (error.response) {
                      console.error('STATUS:', error.response.status)
                      console.error('DATA:', error.response.data)
                      this.step_error1 = false
                      this.progressBar = false
                      this.msj_proceso = error.response.data.message || 'Error en la request'
                    } else {
                      this.step_error1 = false
                      this.progressBar = false
                      this.msj_proceso = 'No hubo respuesta del servidor'
                    }
                    //this.step_txt1="Ocurrio un error"
                    //this.step_error1 = false
                    //this.progressBar = false
                    //this.msj_proceso = error.message
                  })
                  
                  
            },
            
      carga_manual() {
          //this.btn = true
          if (!this.$refs.form.validate()) return
          this.dialogCarga = false
          this.step_txt1="Realizando Carga Manual"
          this.step_txt2=" "
          this.dialog_new = true
          this.e1 = 1
          this.progressBar = true
          this.step_error1 = true
          this.step_error2 = true
          this.step_error3 = true
          this.btnap=true
          this.step_color1 = "primary",
          this.step_color2 = "primary",
          this.step_color3 = "primary",
          this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
          let data = new FormData();
          //this.mvm = []
          data.append('foo', 'bar');
          data.append('file', document.getElementById('file').files[0]);
          data.append('punto', this.ManualItem.punto);
          data.append('proveedor', this.ManualItem.proveedor);
          data.append('orden', this.ManualItem.orden);
          data.append('IncideType', this.ManualItem.IncideType);
          data.append('comentario', this.ManualItem.comentario);
          data.append('user', sessionStorage.getItem('ApiUser_id'));

        axios.post(this.api_tool_url + '/FileUpload_issue', data, this.config)
        .then(response => {
                                
                if(response.data && response.data.ResultRows) {

                    this.e1 = 1
                    this.step_color1 = "#008000"
                    this.progressBar = false
                    this.msj_proceso = response.data.ResultRows
                    this.ManualItem.punto = ''
                    this.ManualItem.orden= ''
                    this.ManualItem.proveedor = ''
                    this.ManualItem.comentario = ''
                    this.ManualItem.IncideType = null
                    this.ManualItem.files = []
                    this.obtenerProveedores()
                    

                }
                else {
                    this.step_txt1="Ocurrio un error"
                    this.e1 = 1
                    this.step_color1 = "#C0392B"
                    this.progressBar = false
                    this.msj_proceso = response.data.error
                    this.ManualItem.punto = ''
                    this.ManualItem.orden= ''
                    this.ManualItem.proveedor = ''
                    this.ManualItem.comentario = ''
                    this.ManualItem.IncideType = null
                    this.ManualItem.files = []
                    
                }
                
            })
            .catch(error => {
                this.btn = false
                this.step_error1 = false
                this.progressBar = false
                if (error.response && error.response.data && error.response.data.message) {
                    this.msj_proceso = error.response.data.message;
                } else {
                    this.msj_proceso = 'Ocurrió un error al procesar el archivo.';
                }
                this.active = true
                
            })
       
      },
      
      onexport () { // On Click Excel download button
            // export json to Worksheet of Excel
          
            const header_d_f = ['id', 'Fecha Incidencia', 'Punto', 'OC', 'Proveedor', 'Razón Social', 'Tipo Incidencia', 'Comentario CD', 'Fecha Turno', 'Hora Turno', 'Marca Desc', 'Pallets', 'Bultos Ultimo Valor', 'Status Mail'];
            const header_d = ['ReceivingIssue_Id', 'Cday_id' ,'OpPoint_id','VendorPurchaseOrder_Num','TurnSrcSupplier_id','TurnSrcSupplier_desc','IssueType_Id','Comment_Txt','TurnDate','TurnHour','TradeMarkType_Description','qty_pa','qty_bu', 'MailStatus'];
            var WS = XLSX.utils.json_to_sheet(this.mvm, {header: header_d}) 

            var range = XLSX.utils.decode_range(WS['!ref']);
            for(var C = range.s.c; C <= range.e.c; ++C) {
              var colum = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
              WS[colum].v = header_d_f[C];
            }

            range.e['c'] = header_d_f.length - 1;
            WS['!ref'] = XLSX.utils.encode_range(range);

            // A workbook is the name given to an Excel file
            var wb = XLSX.utils.book_new() // make Workbook of Excel

            // add Worksheet to Workbook
            // Workbook contains one or more worksheets
            // sheetAName is name of Worksheet
            XLSX.utils.book_append_sheet(wb, WS, 'Reporte de Incidencias')  
            let now = new Date();

            let year = now.getFullYear();
            let month = String(now.getMonth() + 1).padStart(2, '0'); // Mes empieza en 0
            let day = String(now.getDate()).padStart(2, '0');
            let hours = String(now.getHours()).padStart(2, '0');
            let minutes = String(now.getMinutes()).padStart(2, '0');

            var file='ReporteIncidencias_'+year+month+day+'.xlsx';

            // export Excel file
            XLSX.writeFile(wb, file) // name of the file is 'book.xlsx'
          },
      descargapdf(){
        
        this.step_txt1="Armando Reporte"
        this.step_txt2=""
        this.dialog_new = true
        this.e1 = 1
        this.progressBar = true
        this.step_error1 = true
        this.step_error2 = true
        this.step_error3 = true
        this.step_color1 = "primary",
        this.step_color2 = "primary",
        this.step_color3 = "primary",
        this.msj_proceso = "Por favor aguarde un momento ¡No cerrar esta ventana!"
        console.log(this.api_tool_url);
        
        axios.post(this.api_tool_url + '/downloadExcelwithImage_issue', {registros:this.mvm}, {
            headers: this.config.headers,
            responseType: 'blob'
              })
              .then(response => {
                      
                      //prueba del excel con imagen
                      let now = new Date();
                      let year = now.getFullYear();
                      let month = String(now.getMonth() + 1).padStart(2, '0'); // Mes empieza en 0
                      let day = String(now.getDate()).padStart(2, '0');
                      let hours = String(now.getHours()).padStart(2, '0');
                      let minutes = String(now.getMinutes()).padStart(2, '0');
                      const url = window.URL.createObjectURL(response.data)
                      const a = document.createElement('a')
                      a.href = url
                      a.download = 'ReporteIncidencias_'+year+month+day+'.xlsx'
                      document.body.appendChild(a)
                      a.click()
                      document.body.removeChild(a)
                      window.URL.revokeObjectURL(url)
                      this.dialog_new = false
                      this.progressBar = false
                      
                  })
                  .catch(error => {
                    this.step_txt1="Ocurrio un error"
                    this.step_error1 = false
                    this.progressBar = false
                    this.msj_proceso = error.message
                  })

      },

      descargapdf_2(){
        
        this.step_txt1="Armando Reporte"
        this.step_txt2=""
        this.dialog_new = true
        this.e1 = 1
        this.progressBar = true
        this.step_error1 = true
        this.step_error2 = true
        this.step_error3 = true
        this.step_color1 = "primary",
        this.step_color2 = "primary",
        this.step_color3 = "primary",
        this.msj_proceso = "Por favor aguarde un momento ¡No cerrar esta ventana!"
        console.log(this.api_tool_url);
        
        axios.post(this.api_tool_url + '/downloadPDF_reportLab', {registros:this.mvm}, {
            headers: this.config.headers,
            responseType: 'blob'
              })
              .then(response => {
                      
                      //prueba del excel con imagen
                      let now = new Date();
                      let year = now.getFullYear();
                      let month = String(now.getMonth() + 1).padStart(2, '0'); // Mes empieza en 0
                      let day = String(now.getDate()).padStart(2, '0');
                      let hours = String(now.getHours()).padStart(2, '0');
                      let minutes = String(now.getMinutes()).padStart(2, '0');
                      /*const url = window.URL.createObjectURL(response.data)
                      const a = document.createElement('a')
                      a.href = url
                      a.download = 'ReporteIncidencias_'+year+month+day+'.xlsx'
                      document.body.appendChild(a)
                      a.click()
                      document.body.removeChild(a)
                      window.URL.revokeObjectURL(url)
                      */
                      //la que sirve para pdf
                      const url = window.URL.createObjectURL(new Blob([response.data]))
                      const link = document.createElement('a')
                      link.href = url
                      link.setAttribute('download', 'ReporteIncidencias_'+year+month+day+'.pdf')
                      document.body.appendChild(link)
                      link.click()
                      this.dialog_new = false
                      this.progressBar = false
                      
                  })
                  .catch(error => {
                    this.step_txt1="Ocurrio un error"
                    this.step_error1 = false
                    this.progressBar = false
                    this.msj_proceso = error.message
                  })

      },
      close () {
        this.dialog_new = false
        this.dialogCarga = false
        this.dialogpdf = false
      },
      close2 () {
        this.dialog_detail= false
      },
  
      close() {
          this.dialog_new = false
      },
    }
  }
  </script>

<style scoped>
.image-container {
display: flex;
justify-content: center;
align-items: center;
max-height: 70vh;
overflow: auto;
}

.issue-image {
max-width: 100%;
max-height: 70vh;
object-fit: contain;
}
</style>





// WEBPACK FOOTER //
// src/components/SupplierReceivingIssuesGrid.vue